















































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SzksShijuangailan extends Vue {
  @Prop()
  private test;
  @Prop()
  private exam;
  @Prop()
  private student;
  @Prop()
  private leftTime;
  @Prop()
  private answers;
  private jump(index) {
    this.$emit("jump", index);
  }
}
